<template>
  <div class="model-3D relative">
    <!-- <div class="controls">
      <button @click="getCameraPostion">Get Camera Position</button>
    </div> -->
    <div class="btn-main">
      <div>{{ $t("Data Streaming") }}</div>
      <div
        :class="['btn-showData', !iconStatus && 'runstart']"
        @click="showPenalData()"
      >
        <div class="btn-stop" v-show="iconStatus">
          <img src="@/assets/stop.png" alt="" />
        </div>
        <div class="btn-start" v-show="!iconStatus">
          <img src="@/assets/start.png" alt="" />
        </div>
      </div>
    </div>
    <div class="scene relative" id="webgl"></div>
    <Mark :markeData="markeData" v-show="showPenal"></Mark>
    <div id="penal"></div>
  </div>
</template>

<script>
import dat from "dat.gui";
import * as THREE from "three";
import { TweenMax } from "gsap";
import GLTFLoader from "three-gltf-loader";
const OrbitControls = require("three-orbitcontrols");
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import {
  CSS2DRenderer,
  CSS2DObject
} from "three/examples/jsm/renderers/CSS2DRenderer.js";

import Mark from "./Marke.vue";

var gui;
let renderer,
  controls,
  scene,
  camera,
  css2DRenderer,
  ambientLight,
  pointLight1,
  pointLight2,
  positions = {
    罗茨泵非驱动点: [],
    罗茨泵驱动点: [],
    罗茨泵电机非驱动点: [],
    罗茨泵电机驱动点: [],
    螺杆泵非驱动点: [],
    螺杆泵驱动点: [],
    螺杆泵电机非驱动点: [],
    螺杆泵电机驱动点: []
  };

/* 加载纹理 */
// function loadTextures(img) {
//   var texture = THREE.TextureLoader(img);
//   texture.wrapS = THREE.RepeatWrapping;
//   texture.wrapT = THREE.RepeatWrapping;
//   texture.repeat.set(100, 20);
//   var materialss = new THREE.MeshBasicMaterial({
//     map: texture,
//     side: THREE.DoubleSide
//   });
//   return materialss;
// }
export default {
  name: "VSD420-H-Model",
  data() {
    return {
      iconStatus: true,
      showPenal: false,
      penalList: [],
      modelObjects: []
    };
  },
  props: {
    modelList: {
      /* 模型 */
      type: Array,
      default: null,
      required: true
    },
    markeData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Mark
  },
  mounted() {
    this.init();
    // this.initGui(); // 灯光调试工具
    // window.addEventListener("click", e => {
    //   console.log(e);
    // });
  },
  methods: {
    /* 切换展示按钮 */
    showPenalData() {
      controls.autoRotate = !controls.autoRotate;
      controls.enableRotate = !controls.enableRotate;
      this.iconStatus = !this.iconStatus;
      if (!controls.autoRotate) {
        this.moveAnimate();
      } else {
        this.setVisibel(false);
      }
    },
    async moveAnimate() {
      await TweenMax.to(camera.position, 2, {
        x: 120,
        y: 48,
        z: -18
      });
      this.setVisibel(true);
    },
    setVisibel(status) {
      this.penalList.forEach(penal => {
        penal.visible = status;
      });
      this.modelObjects.forEach(object => {
        object.visible = status;
      });
    },
    getCameraPostion() {
      alert(JSON.stringify(camera.position));
    },
    createLine(
      position1 = { x: 0, y: 0, z: 0 },
      position2 = { x: 0, y: 0, z: 0 }
    ) {
      let geometry = new THREE.Geometry();
      let lineMaterial = new THREE.LineBasicMaterial({
        color: "#01E7FF"
      });
      geometry.vertices.push(
        new THREE.Vector3(position1.x, position1.y, position1.z),
        new THREE.Vector3(position2.x, position2.y, position2.z)
      );
      let line = new THREE.Line(geometry, lineMaterial);
      scene.add(line);
    },
    createMarker(id, { x, y, z }) {
      let domObject = new CSS2DObject(document.getElementById(id));
      domObject.position.x = x;
      domObject.position.y = y;
      domObject.position.z = z;
      domObject.visible = false;
      return domObject;
    },
    /* 清空模型 */
    clearModel() {
      if (scene && scene.children.length >= 1) {
        scene.children.map(item => {
          scene.remove(item);
        });
        scene.children = [];
        let domDiv = document.querySelector("#webgl");
        if (domDiv != null) {
          domDiv.innerHTML = "";
        }
        camera = null;
        controls = null;
        scene = null;
        renderer.dispose();
        renderer = null;
      }
    },
    init() {
      document.querySelector("#webgl").innerHTML = "";
      this.clearModel();

      /* 场景 */
      scene = new THREE.Scene();
      scene.scale.set(0.5, 0.5, 0.5);

      /* 相机设置 */
      camera = new THREE.PerspectiveCamera(
        75,
        window.innerWidth / window.innerHeight,
        1,
        2000
      );
      camera.position.set(120, 48, -18);
      camera.lookAt(new THREE.Vector3(0, 0, 0));
      /* 模型加载 */
      var loader = new GLTFLoader();
            var dracoLoader = new DRACOLoader()
            dracoLoader.setDecoderPath("three/examples/jsm/libs/draco/gltf");
            dracoLoader.setDecoderConfig({ type: "js" });
            dracoLoader.preload()
            loader.setDRACOLoader(dracoLoader);

      this.modelList.map((item) => {
        loader.load(
          item,
          gltf => {
            // console.log(gltf.scene);
            let model = gltf.scene;
            gltf.scene.traverse(object => {
              if (object.isMesh) {
                object.material.emissiveMap = object.material.map;
              }

              if (positions[object.name]) {
                positions[object.name] = object.position;
              }

              if (object.name == "干泵-罗茨泵") {
                // this.createLine(positions["罗茨泵非驱动点"], object.position);
                // this.createLine(positions["罗茨泵驱动点"], object.position);
                let marke_lcb_fqd = this.createMarker(
                  "marke-lcb-fqd",
                  positions["罗茨泵非驱动点"]
                );
                let marke_lcb_qd = this.createMarker(
                  "marke-lcb-qd",
                  positions["罗茨泵驱动点"]
                );
                this.penalList.push(marke_lcb_fqd, marke_lcb_qd);
                scene.add(marke_lcb_fqd, marke_lcb_qd);
              }

              if (object.name == "干泵-罗茨泵电机") {
                // this.createLine(
                //   positions["罗茨泵电机非驱动点"],
                //   object.position
                // );
                // this.createLine(positions["罗茨泵电机驱动点"], object.position);
                let marke_lcbdj_fqd = this.createMarker(
                  "marke-lcbdj-fqd",
                  positions["罗茨泵电机非驱动点"]
                );
                let marke_lcbdj_qd = this.createMarker(
                  "marke-lcbdj-qd",
                  positions["罗茨泵电机驱动点"]
                );
                this.penalList.push(marke_lcbdj_fqd, marke_lcbdj_qd);
                scene.add(marke_lcbdj_fqd, marke_lcbdj_qd);
              }

              if (object.name == "干泵-罗杆泵") {
                // this.createLine(positions["螺杆泵非驱动点"], object.position);
                let marke_lgb_qd = this.createMarker(
                  "marke-lgb-qd",
                  positions["螺杆泵驱动点"]
                );

                let marke_lgb_fqd = this.createMarker(
                  "marke-lgb-fqd",
                  positions["螺杆泵非驱动点"]
                );
                // this.createLine(positions["螺杆泵驱动点"], object.position);
                this.penalList.push(marke_lgb_fqd, marke_lgb_qd);
                scene.add(marke_lgb_fqd, marke_lgb_qd);
              }

              if (object.name == "干泵-罗杆泵电机") {
                // this.createLine(
                //   positions["螺杆泵电机非驱动点"],
                //   object.position
                // );
                let marke_lgbdj_fqd = this.createMarker(
                  "marke-lgbdj-fqd",
                  positions["螺杆泵电机非驱动点"]
                );

                // this.createLine(positions["螺杆泵电机驱动点"], object.position);
                let marke_lgbdj_qd = this.createMarker(
                  "marke-lgbdj-qd",
                  positions["螺杆泵电机驱动点"]
                );
                this.penalList.push(marke_lgbdj_fqd, marke_lgbdj_qd);
                scene.add(marke_lgbdj_fqd, marke_lgbdj_qd);
              }

              if (object.name.includes("线")) {
                object.visible = false;
                this.modelObjects.push(object);
              }
            });
            mixer = new THREE.AnimationMixer(gltf.scene);

            if (gltf.animations.length) {
              let animationAction = mixer.clipAction(gltf.animations[0]).play();
              animationActions.push(animationAction);
            }

            scene.add(model);
          },
          evt => {
            console.log(evt);
          },
          function(error) {
            console.error(error);
          }
        );
      });

      /* css渲染器 */
      css2DRenderer = new CSS2DRenderer();
      css2DRenderer.setSize(
        document.querySelector("#webgl").offsetWidth,
        document.querySelector("#webgl").offsetHeight
      );
      css2DRenderer.domElement.style.position = "absolute";
      css2DRenderer.domElement.style.top = "0";
      document.getElementById("penal").appendChild(css2DRenderer.domElement);

      /* 渲染器 */
      renderer = new THREE.WebGLRenderer({ alpha: true });
      this.$nextTick(() => {
        renderer.setSize(
          document.querySelector("#webgl").offsetWidth,
          document.querySelector("#webgl").offsetHeight
        );
      });
      renderer.setClearColor(0xffffff, 0);
      renderer.setPixelRatio(window.devicePixelRatio);
      document.getElementById("webgl").appendChild(renderer.domElement);

      let clock = new THREE.Clock();

      let mesh;
      let mixer = new THREE.AnimationMixer(mesh);
      let animationActions = [];

      //控制器
      controls = new OrbitControls(
        camera,
        document.getElementById("webgl"),
        renderer.domElement
      );
      /* 缩放 */
      controls.enableZoom = false;
      controls.enablePan = false;
      /* 旋转 */
      controls.enableRotate = true;
      controls.autoRotate = true;
      controls.autoRotateSpeed = 0.5;
      /* 阻尼系数 */
      controls.enableDamping = true;
      controls.dampingFactor = 0.1;
      //限制垂直方向的旋转
      controls.minPolarAngle = Math.PI * 0.38;
      controls.maxPolarAngle = Math.PI * 0.38;

      //light
      this.setLight();

      const animate = () => {
        controls.update();
        var delta = clock.getDelta();
        if (mixer != null) {
          mixer.update(delta);
        }

        renderer.render(scene, camera);

        if (gui) {
          pointLight1.position.x = gui.PlightX_4;
          pointLight1.position.y = gui.PlightY_4;
          pointLight1.position.z = gui.PlightZ_4;

          pointLight2.position.x = gui.PlightX_5;
          pointLight2.position.y = gui.PlightY_5;
          pointLight2.position.z = gui.PlightZ_5;
        }
        css2DRenderer.render(scene, camera);

        requestAnimationFrame(animate);
      };

      animate();
    },
    /* 全景灯光 */
    setLight() {
      ambientLight = new THREE.AmbientLight(0xffffff, 1);
      ambientLight.position.set(0, 100, 0);

      pointLight1 = new THREE.PointLight(0xffffff, 0.8);
      pointLight1.position.set(-2616, 1719, 1502);

      pointLight2 = new THREE.PointLight(0xffffff, 0.8);
      pointLight2.position.set(202, 202, -232);

    //   var helper1 = new THREE.PointLightHelper(pointLight1, 100);
    //   var helper5 = new THREE.PointLightHelper(pointLight2, 100);

      //  scene.add(helper1, helper5);

      scene.add(ambientLight, pointLight1, pointLight2);
    },
    initGui() {
      //声明一个保存需求修改的相关数据的对象
      gui = {
        PlightX_4: -2616,
        PlightY_4: 1719,
        PlightZ_4: 1502,

        PlightX_5: 202,
        PlightY_5: 202,
        PlightZ_5: -232
      };
      var datGui = new dat.GUI();
      //将设置属性添加到gui当中，gui.add(对象，属性，最小值，最大值）
      datGui.add(gui, "PlightX_4", -10000, 10000);
      datGui.add(gui, "PlightY_4", -10000, 10000);
      datGui.add(gui, "PlightZ_4", -10000, 10000);

      datGui.add(gui, "PlightX_5", -10000, 10000);
      datGui.add(gui, "PlightY_5", -10000, 10000);
      datGui.add(gui, "PlightZ_5", -10000, 10000);
    }
  }
};
</script>


<style scoped lang="scss">
.model-3D {
  width: 100%;
  height: 100%;
  .scene {
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  .controls {
    position: absolute;
    top: 0%;
    left: 50%;
    z-index: 999;
  }

  #penal {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .btn-main {
    position: absolute;
    top: 0%;
    right: 25%;
    z-index: 9999;
    display: flex;
    flex-flow: column;
    align-items: center;
    font-size: 18px;
    .btn-showData {
      margin-top: 5px;
      border: 3px solid #00e7ff;
      filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
      border-radius: 30px;
      padding: 5px 8px;
      display: flex;
      align-items: center;
      width: 82px;
      &:hover {
        cursor: pointer;
      }
      .btn-stop {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        background: #02364b;
        border-radius: 50%;
        padding: 6px;
        margin-right: 20px;
      }
      .btn-start {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        background: #02364b;
        border-radius: 50%;
        padding: 6px;
      }
      &.runstart {
        justify-content: flex-end;
        background: #00e7ff;
      }
    }
  }
}
</style>
